import React, { PropTypes } from "react";
import { FormattedMessage, intlShape } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { change as changeFieldValue, Field, formValueSelector, reduxForm, } from "redux-form";
import {
  CheckboxInput,
  DayPicker,
  NewSelectInput,
  SelectInput,
  TextInput
} from "../../../../../../common/form";

import validationUtils from "../../../../../../../utils/ValidationUtils";
import { Render } from "../../../../../../common";
import genders from "../../enums/genders";
import { DEPENDENTS_VALIDATION_RULES } from "./dependentsValidationRules";
import dependentRelations from "./enums/dependentRelations";
import { RECURRING } from "../../../../enums/billingPeriodTypes";

class BasicDependentFields extends React.Component {
  constructor(props, context) {
    super(props, context);
  }
  getChildContext() {
    return {
      scene: this.props.scene,
    };
  }


  render() {
    const currentDate = new Date();
    return (
      <form onSubmit={this.props.handleSubmit}>
        <fieldset disabled={this.props.disabled}>
          <Field
            id="firstName"
            name="firstName"
            component={TextInput}
            type="text"
            label={<FormattedMessage id="dependents.form.firstName" />}
          />
          <Field
            id="lastName"
            name="lastName"
            component={TextInput}
            type="text"
            label={<FormattedMessage id="dependents.form.lastName" />}
          />
          <Field
            id="genderType"
            name="genderType"
            component={SelectInput}
            disabled={this.props.disabled}
            options={genders}
            addBlankOption={true}
            label={<FormattedMessage id="dependents.form.gender" />}
          />
          <Field
            id="relationshipType"
            name="relationshipType"
            component={SelectInput}
            disabled={this.props.disabled}
            options={dependentRelations}
            addBlankOption={true}
            label={<FormattedMessage id="dependents.form.relation" />}
          />
          <Field
            id="birthdate"
            name="birthdate"
            component={DayPicker}
            label={<FormattedMessage id="dependents.form.birthdate" />}
          />
          <Field
            id="isSmoker"
            name="isSmoker"
            addBlankOption={true}
            blankMessageKey="common.nd"
            options={[
              { value: false, key: "common.no" },
              { value: true, key: "common.yes" },
            ]}
            component={NewSelectInput}
            disabled={this.props.disabled}
            label={<FormattedMessage id="dependents.form.smoker" />}
          />
          <Render
            if={
              this.props.clientBillingPeriodType == RECURRING.value
            }
          >
            <Field
              id="isDisabled"
              name="isDisabled"
              component={CheckboxInput}
              checkbox={{ value: true }}
              label={
                <FormattedMessage id="dependents.form.isDisabled" />
              }
              disabled={this.props.disabled}
              normalize={(value) => !!value}
            />
            <Render
              if={
                this.props.isDisabled
              }
            >
              <Field
                id="disabilityStartDate"
                name="disabilityStartDate"
                component={DayPicker}
                maxDate={currentDate}
                minDate={this.props.birthdate}
                label={<FormattedMessage id="dependents.form.disabilityStartDate" />}
                required={this.props.isDisabled}
                hintKey="dependents.form.disabilityStartDateHint"
              />
            </Render>
          </Render>

        </fieldset>
      </form>
    );
  }
}

BasicDependentFields.propTypes = {
  disabled: PropTypes.bool,
  initialValues: PropTypes.object,
  scene: PropTypes.string,
  validation: PropTypes.object,
  handleSubmit: PropTypes.func,
  divisionList: PropTypes.array,
  changeFieldValue: PropTypes.func,
  isDisabled: PropTypes.bool,
  birthdate: PropTypes.object,
  clientBillingPeriodType: PropTypes.string,
};

BasicDependentFields.defaultProps = {
  disabled: false,
  scene: "",
};

BasicDependentFields.contextTypes = {
  getData: PropTypes.func,
  intl: intlShape,
  handleInputBlur: PropTypes.func,
  handleInputChange: PropTypes.func,
};

BasicDependentFields.childContextTypes = {
  scene: PropTypes.string,
};

function mapStateToProps(state) {

  const selector = formValueSelector("dependent");

  return {
    isDisabled: selector(state, "isDisabled"),
    birthdate: selector(state, "birthdate"),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    changeFieldValue: bindActionCreators(changeFieldValue, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(
  reduxForm({
    form: "dependent",
    validate: (values) =>
      validationUtils.validate(values, DEPENDENTS_VALIDATION_RULES),
  })(BasicDependentFields)
);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/members/member/dependents/BasicDependentFields.js